import { render, staticRenderFns } from "./AboutEn.vue?vue&type=template&id=33d61d58&scoped=true&"
import script from "./AboutEn.vue?vue&type=script&lang=js&"
export * from "./AboutEn.vue?vue&type=script&lang=js&"
import style0 from "./AboutEn.vue?vue&type=style&index=0&id=33d61d58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d61d58",
  null
  
)

export default component.exports